import api from "../api";
import formCleaner from "../_utils/cleaner";
import {
  addSnackbarMessage,
  addSuccessSnackbarMessage,
} from "../../Common/_plugin/error-response";
import { v4 as uuidv4, validate as validateUUID } from "uuid";

function fetchEditorFormMaster(context, masterIdOrSlug) {
  api
    .fetchFormById(masterIdOrSlug)
    .then((result) => context.commit("setEditorActiveFormMaster", result.data))
    .catch((err) => {
      console.error(err);
      context.commit("setEditorFormFetchError", true);
    });
}

function fetchEditorFormVersion(context, versionId) {
  api
    .fetchFormVersionById(versionId)
    .then((result) => context.commit("setEditorActiveFormVersion", result.data))
    .catch((err) => {
      console.error(err);
      context.commit("setEditorFormFetchError", true);
    });
}

function fetchEditorFormVersionBySlug(context, slug) {
  api
    .fetchFormVersionByHash(slug)
    .then((result) => {
      context.commit("setEditorActiveFormMaster", result.data.form_master);
      context.commit("setEditorActiveFormVersion", result.data);
    })
    .catch((err) => {
      console.error(err);
      context.commit("setEditorFormFetchError", true);
    });
}

function getAllFormMasters(context) {
  api
    .fetchAllForms()
    .then((result) => context.commit("setAllFormMasters", result.data))
    .catch((err) => console.error(err));
}

function getPublishedFormMasters(context) {
  api
    .fetchPublishedForms()
    .then((result) => {
      context.commit("setAllPublishedForms", result.data);
    })
    .catch((err) => console.error(err));
}

function getAllFormVersions(context, masterId) {
  api
    .fetchFormVersionsByFormId(masterId)
    .then((result) => context.commit("setAllFormVersions", result.data))
    .catch((err) => console.error(err));
}

function saveFormMaster(context, data) {
  api
    .editFormTemplate({ data })
    .then(() => {
      context.commit("setFormMaster", data);
      context.dispatch(
        "openSnackbar",
        {
          type: "success",
          message: "Form updated successfully!",
        },
        { root: true }
      );
    })
    .catch((error) => {
      const errorMessage =
        error?.response?.data?.message ?? "Problem in saving form.";
      addSnackbarMessage(error, errorMessage, true);
    });
}

function deleteFormMaster(context, id) {
  api
    .deleteFormTemplate(id)
    .then(() => {
      context.commit("removeFormMaster", id);
      context.dispatch(
        "openSnackbar",
        {
          type: "success",
          message: "Form deleted successfully!",
        },
        { root: true }
      );
    })
    .catch((error) => {
      const errorMessage =
        error?.response?.data?.message ?? "Problem in deleting form.";
      addSnackbarMessage(error, errorMessage, true);
    });
}

function addFormMaster(context, data) {
  api
    .addFormTemplate({ data })
    .then((result) => context.commit("addFormMaster", result.data))
    .catch((err) => console.error(err));
}

function saveFormVersion(context, data) {
  if (data.status === "P") {
    for (const section of data.form_json.sections) {
      for (const question of section.body) {
        if (!validateUUID(question.key)) {
          question.key = uuidv4();
        }
        if (!(question.showConditionally && question.conditionalQuestion.key)) {
          question.showConditionally = false;
          question.conditionalQuestion = {
            key: null,
            questionLabel: "",
            value: "",
          };
        }
      }
    }
  }
  const result = formCleaner(data.form_json);
  if (result.value)
    return api
      .saveFormVersion({ data })
      .then((res) => {
        context.commit("setFormSaved", "saved");
        if (data.status === "P") {
          addSuccessSnackbarMessage("Form published successfully");
        } else {
          addSuccessSnackbarMessage("Form saved successfully");
        }
        // RETURN response
        return {
          master: { id: res.data.formMasterId },
          version: { id: res.data.id },
        };
      })
      .catch((err) => {
        context.commit("setFormSaved", "error");
        context.commit("setErrorMessage", err.response.data.message);
      });
  else {
    addSnackbarMessage({}, result.message, true);
    return Promise.reject(new Error(result.message));
  }
}

const discardFormVersion = (context, payload) => {
  api.discardFormVersion(payload).then(() => {
    context.commit("removeFormVersion", payload);
  });
};

const copyFormMaster = (context, payload) => {
  api
    .copyFormMaster(payload.formMasterId, payload.title)
    .then((result) => {
      context.commit("addFormMaster", result.data.formMaster);
      addSuccessSnackbarMessage("Form copied successfully");
    })
    .catch((error) => {
      const errorMessage =
        error?.response?.data?.message ?? "Problem in copying form.";
      addSnackbarMessage(error, errorMessage, true);
    });
};

const copyFormVersion = (context, payload) => {
  api
    .copyFormVersion(payload.formMasterId, payload.formVersionId)
    .then((result) => {
      context.commit("addFormVersion", {
        formMasterId: result.data.formMasterId,
        formVersion: result.data.formVersion,
      });
    });
};

export default {
  fetchEditorFormMaster,
  fetchEditorFormVersion,
  getAllFormMasters,
  getPublishedFormMasters,
  getAllFormVersions,
  saveFormMaster,
  deleteFormMaster,
  addFormMaster,
  saveFormVersion,
  fetchEditorFormVersionBySlug,
  discardFormVersion,
  copyFormMaster,
  copyFormVersion,
};
